import { z } from "zod";
import type { ValidationTranslator } from "@/components/upload/draftFormSchema";

/**
 * The document fields the upload form and the draft review dialog validate identically. An
 * empty amount (a draft extraction could not read) asks for one rather than reading as 0. The
 * messages come from `consultantDraft.validation`, in the language the app shows.
 */
export function createDocumentFormFields(t: ValidationTranslator) {
  return {
    vendor: z.string().optional(),
    amount: z.coerce.number({ error: t("amountRequired") }).positive({ message: t("amountPositive") }),
    currency: z.string().min(1, { message: t("currencyRequired") }),
    dueDate: z.string().optional(),
    transactionDate: z.string().optional(),
  };
}
